<template>
  <div>
    <template v-if="(parentFilter.tahun && parentFilter.kolok)">
      <b-overlay :show="isLoadDetail" variant="light" opacity="0.85" blur="2px" rounded="sm">
        <div style="min-height: 200px;">
          <div v-for="(itemHead, i) in resp" :key="i" class="card mb-2"
            :class="(itemHead.kode == 'laporan_belum_selesai_0') ? 'border border-danger' : ''">
            <div class="card-header">
              <div class="card-title">
                <h4 class="font-weight-bolder text-uppercase text-primary"
                  :class="(itemHead.kode == 'laporan_belum_selesai_0') ? 'text-danger' : ''">
                  {{ itemHead.header }}
                </h4>
              </div>
            </div>
            <div class="card-body overflow-auto mb-2 pr-2">
              <div class="mb-1">
                <template v-if="itemHead.kode == 'lhi_0'">
                  <div>
                    Dokumen dapat <span class="font-weight-bolder">diupload</span> setelah hasil sensus <span
                      class="font-weight-bolder">divalidasi Kepala PD/UKPD/UPB!</span>
                  </div>
                </template>
                <template v-else-if="itemHead.kode == 'laporan_belum_selesai_0'">
                </template>
                <template v-else>
                  <div>
                    Dokumen dapat <span class="font-weight-bolder">dicetak dan diupload</span> setelah hasil sensus
                    <span class="font-weight-bolder">divalidasi Kepala PD/UKPD/UPB!</span>
                  </div>
                </template>
              </div>
              <table class="table table-bordered table-hover-cell ">
                <thead class="font-weight-bold"
                  :class="(itemHead.kode == 'laporan_belum_selesai_0') ? 'bg-light-danger ' : 'bg-light-primary'">
                  <tr>
                    <td class="w-100">Jenis Laporan</td>
                    <td class="text-center">Cetak</td>
                    <td v-if="i == '0'">Jumlah Register</td>
                    <td v-if="i == '0'" class="text-nowrap">Nilai (Rp)</td>
                    <td class="text-center text-nowrap">File Dokumen</td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, il) in itemHead.laporan">
                    <tr>
                      <td>{{ item.nama_laporan }}</td>
                      <td class="text-center">
                        <template v-if="itemHead.kode == 'lhi_0' && !hideCetak" style="display:none">
                          <b-button v-if="item.url_cetak && $can('Cetak-Dokumen-B', 'b-dokumen-inventarisasi')"
                            v-ripple.400="' rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="sm"
                            @click="cetakDokumen(item.url_cetak)" class="d-flex text-nowrap">
                            <feather-icon icon="PrinterIcon" class="mr-50" />Cetak
                          </b-button>
                        </template>
                        <template
                          v-else-if="itemHead.kode != 'lhi_0' && kolokData.status_hasil_akhir == 'disetujui-ka' && !hideCetak" style="display:none">
                          <b-button v-if="item.url_cetak && $can('Cetak-Dokumen-B', 'b-dokumen-inventarisasi')"
                            v-ripple.400="' rgba(255, 255, 255, 0.15)'"
                            :variant="(itemHead.kode == 'laporan_belum_selesai_0') ? 'outline-danger' : 'outline-primary'"
                            size="sm" @click="cetakDokumen(item.url_cetak)" class="d-flex text-nowrap">
                            <feather-icon icon="PrinterIcon" class="mr-50" />Cetak
                          </b-button>
                        </template>
                        <template v-else>
                          <div class="text-nowrap"> - </div>
                        </template>
                      </td>
                      <td v-if="i == '0'">{{ item.jumlah_register }}</td>
                      <td v-if="i == '0'">{{ item.nilai }}</td>
                      <td class="">
                        <template v-if="item.file">
                          <div class="d-flex justify-content-between">
                            <div class="mr-1">
                              <b-button v-if="!isFinal && $can('Upload-Dokumen', 'b-dokumen-inventarisasi')"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-warning" size="sm"
                                @click="openUploadDokumenDialog(item)" class="w-100 text-nowrap">
                                <feather-icon icon="SendIcon" class="mr-50" />
                                <span class="align-middle">Upload Ulang</span>
                              </b-button>
                              <b-button v-else-if="isFinal && itemHead.kode === 'kir_0' && $can('Upload-Dokumen', 'b-dokumen-inventarisasi')"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-warning" size="sm"
                                @click="openUploadDokumenDialog(item)" class="w-100 text-nowrap">
                                <feather-icon icon="SendIcon" class="mr-50" />
                                <span class="align-middle">Upload Ulang</span>
                              </b-button>
                            </div>
                            <div>
                              <b-button v-if="$can('Download-Dokumen-B', 'b-dokumen-inventarisasi')" style="display:none"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-success" size="sm"
                                @click="downloadFile(item.file)" class="w-100 text-nowrap">
                                <feather-icon icon="SendIcon" class="mr-50" />
                                <span class="align-middle">Download</span>
                              </b-button>
                            </div>
                          </div>
                          <div class="mt-50" style="font-size: 12px;">
                            <div>
                              Diupload Oleh : {{ item.created_by }}
                            </div>
                            <div>
                              Diupload Pada : {{ parserValue('dateTime',
                                item.created_at) || '-' }}
                            </div>
                            <div>
                              Upload Ke : {{ item.upload_ke }}
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <template v-if="kolokData.status_hasil_akhir == 'disetujui-ka'">
                            <div v-if="item.file == null">
                              <b-button v-if="$can('Upload-Dokumen', 'b-dokumen-inventarisasi')"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-danger" size="sm"
                                @click="openUploadDokumenDialog(item)" class="w-100 text-nowrap">
                                <feather-icon icon="SendIcon" class="mr-50" />
                                <span class="align-middle">Upload</span>
                              </b-button>
                            </div>
                          </template>
                          <template v-else>
                            <div class="text-nowrap text-center"> - </div>
                          </template>
                        </template>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-overlay>
    </template>
    <template v-else>
      <div class="card">
        <div class="card-header d-block border-bottom">
          <div class="text-center">
            <h4 class="font-weight-bolder text-uppercase text-primary">Dokumen Inventarisasi
            </h4>
          </div>
        </div>
        <div class="misc-wrapper">
          <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
              <b-alert show variant="primary" class="m-0 mb-2">
                <div class="alert-body p-3">
                  <div class="d-flex flex-row justify-content-center" style="gap: 5px;">
                    <div class="icon-wrapper">
                      <feather-icon :icon="'InfoIcon'" class="mr-50" />
                    </div>
                    <div>
                      <span class="font-weight-bold">
                        Silahkan pilih PD/UKPD/UPB untuk melihat data Dokumen Inventarisasi.
                      </span>
                    </div>
                  </div>
                </div>
              </b-alert>
              <b-img fluid :src="imgUrl" alt="Coming soon page" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal centered id="modal-upload-dokumen" ref="uploadDokumenModalRef" scrollable :no-close-on-backdrop="true"
      title="Upload Dokumen" cancel-title="Batal" ok-title="Kirim" cancel-variant="outline-secondary"
      @ok="confirmSubmitDokumen">
      <validation-observer ref="modalUploadDokumenRules">
        <div class="row">
          <div class="col-12">
            <div class="mb-1">
              <span class="font-weight-bold"> {{ modalUploadDokumenTitle }}</span>
            </div>
            <div>
              <validation-provider #default="{ errors }" name="File Dokumen SK Tim" rules="required">
                <div class="d-flex flex-wrap flex-row" style="gap:20px;margin-top: 5px;">
                  <b-form-file v-model="uploadedFile"
                    accept="application/pdf,application/zip, application/x-zip-compressed" @change="handleFileChange" />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div>
              <span class="text-danger">*</span> <small class="text-danger">Maksimal 2 mb dan format PDF/Zip</small>
            </div>
          </div>
        </div>
      </validation-observer>
      <template slot="modal-footer">
        <b-button v-if="!loadingSubmitDokumen" variant="primary" @click="confirmSubmitDokumen">
          <span class="align-middle">Kirim</span>
        </b-button>
        <b-button v-else variant="primary" disabled>
          <b-spinner small />
          Loading...
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ref, nextTick, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import dokumenInventarisasi from "@/composables/b/dokumenInventarisasi";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { showNotifikasi } from '@/libs/helper';
import { parserValue } from '@/libs/helper'
import { BFormFile, BModal, VBModal } from 'bootstrap-vue'
import { id as localeId } from "vee-validate/dist/locale/id";
import { VueGoodTable } from "vue-good-table";
import hasilSensus from "@/composables/b/hasilSensus";
import { closeSistemKibB } from '@/libs/helper';

export default {
  props: {
    fd: { type: Object, required: true },
    parentFilter: { type: Object, required: true }
  },
  setup(props, context) {
    const g = context.root;
    const $route = g.$route;
    const formDatas = ref({});
    const kolokData = ref({});
    const isLoadDetail = ref(false);
    const isFinal = ref(false);
    const getData = () => {
      isLoadDetail.value = true;
      let params = {
        tahun: props.parentFilter.tahun,
        filter_kolok: props.parentFilter.kolok,
        kolok: props.parentFilter.kolok,
        show_laporan_belum_selesai: true,
      };
      if ((params.tahun && params.filter_kolok)) {
        hasilSensus.getDetail(g, params).then(res => {
          kolokData.value = { ...res.data }
        }).catch(err => {
          console.log(err)
        });
        //
        dokumenInventarisasi.getDetail(g, params).then(res => {
          resp.value = res.data
          console.log(res)
          isLoadDetail.value = false;
          isFinal.value = Boolean(Number(res.is_final));
        }).catch(err => {
          isLoadDetail.value = false;
          console.log(err)
        });
      }
    };
    getData();
    //global variable

     // Trigger login API untuk muncul di network
    const triggerLoginAPI = () => {
      const username = g.$cookies.get('username');
      console.log(username);
    };
    // Panggil saat component mounted
    triggerLoginAPI();
    
    const username = ref(g.$cookies.get('username'));
    const usernameMatch = computed(() => {
      const match = username.value?.match(/^(\d+)([A-Z])$/);
      return match ? { number: match[1], letter: match[2] } : null;
    });
    const hideCetak = computed(() => {
      return usernameMatch.value && usernameMatch.value.number === props.parentFilter.kolok && 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.includes(usernameMatch.value.letter);
    });
    
    //global variable


    const resp = ref([]);

    /* Download Upload Dokumen SK Tim */
    // https://jakaset.jakarta.go.id/staging/sensus-pengguna-b/report/kir?kolok=00010
    const cetakDokumen = (url) => {
      let queryParams = '?kolok=' + props.parentFilter.kolok;;
      const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + url + queryParams; // Replace with your specific link
      window.open(linkToOpen, '_blank');
    };

    /* Upload Dokumen */
    const formDatasDokumen = ref({});
    const modalUploadDokumenTitle = ref('');
    const uploadDokumenModalRef = ref(null);
    const openUploadDokumenDialog = (item) => {
      modalUploadDokumenTitle.value = item.nama_laporan;
      formDatasDokumen.value.kode_laporan = item.kode_laporan;
      formDatasDokumen.value.nama_laporan = item.nama_laporan;
      uploadDokumenModalRef.value.show();
    };
    const uploadedFile = ref(null);
    const handleFileChange = (event) => {
      formDatasDokumen.value.file_laporan = null;
      const fileInput = event.target;
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileSize = fileInput.files[0].size / 1024 / 1024; // in MB
        // const maxFileSize = 2; // 2 MB
        const allowedFileTypes = ['application/pdf', 'application/zip', 'application/x-zip-compressed'];

        if (!allowedFileTypes.includes(file.type)) {
          showNotifikasi(g, 'warning', 'Warning', `File yang diupload harus berformat PDF/Zip`);
          uploadedFile.value = null;
          fileInput.value = '';
        }
        // else if (fileSize > maxFileSize) {
        //   showNotifikasi(g, 'warning', 'Warning', `File yang diupload maksimal ${maxFileSize} Mb`);
        //   uploadedFile.value = null;
        //   fileInput.value = '';
        // } 
        else {
          formDatasDokumen.value.file_laporan = file;
        }
      }
    }
    const loadingSubmitDokumen = ref(false);
    const confirmSubmitDokumen = (bvModalEvt) => {
      bvModalEvt.preventDefault();
      context.refs.modalUploadDokumenRules.validate().then(success => {
        if (success) {
          const fd = new FormData()
          fd.append('username', g.$cookies.get('username'))
          fd.append('tahun', props.parentFilter.tahun)
          fd.append('kolok', props.parentFilter.kolok)
          fd.append('file_laporan', formDatasDokumen.value.file_laporan)
          fd.append('kode_laporan', formDatasDokumen.value.kode_laporan)
          loadingSubmitDokumen.value = true;
          dokumenInventarisasi.uploadDokumen(g, fd).then(resp => {
            if (resp.success) {
              getData();
              showNotifikasi(g, 'success', 'Success', resp.message)
              nextTick();
              context.refs.uploadDokumenModalRef.toggle('#toggle-btn');
              formDatasDokumen.value = {};
              context.emit('changeStateEvent', 'detail');
              loadingSubmitDokumen.value = false;
            } else {
              showNotifikasi(g, 'danger', 'Error', resp.message)
              loadingSubmitDokumen.value = false;
            }
          }).catch(err => {
            console.log(err)
            loadingSubmitDokumen.value = false;
          });
        }
      });
    };

    const downloadFile = (url) => {
      window.open(url, '_blank');
    }

    const closeSistemInformation = ref({});
    setInterval(() => {
      closeSistemInformation.value = closeSistemKibB();
    }, 1000);
    return {
      isLoadDetail,
      resp,
      getData,
      cetakDokumen,
      uploadDokumenModalRef,
      openUploadDokumenDialog,
      confirmSubmitDokumen,
      handleFileChange,
      loadingSubmitDokumen,
      uploadedFile,
      modalUploadDokumenTitle,
      downloadFile,
      parserValue,
      kolokData,
      closeSistemInformation,
      isFinal,
      hideCetak,
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BModal,
    VueGoodTable,
  },
  watch: {
    parentFilter: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
  },
  data() {
    return {
      imgUrl: require('@/assets/images/pages/under-maintenance.svg'),
    };
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
}
</script>